import { h, Component } from "preact";
import { css, keyframes } from "emotion";

const loadingIcon = require("../../assets/loader.svg");

const animationKeyframes = keyframes({
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(359deg)"
  }
});

const loadingCss = css({
  animation: `${animationKeyframes} 2s infinite linear`,
  marginBottom: 24
});

const Loading = () => {
  return <img src={loadingIcon} className={loadingCss} />;
};

export default Loading;
